import { submissionReadinessApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Read-only, all-roles (DEV-3782). A 403 (broker-auth gap) must degrade to the
// neutral state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const SUBMISSION_READINESS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/submissionReadiness`,
  {
    SET_SUBMISSION_READINESS: 'SET_SUBMISSION_READINESS',
  },
);

export const getSubmissionReadinessAction = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await submissionReadinessApi.getSubmissionReadiness({
        applicationId,
        config: SKIP_FORBIDDEN_CONFIG,
      });

      return dispatch({
        type: SUBMISSION_READINESS_ACTION_TYPE.SET_SUBMISSION_READINESS,
        payload: { applicationId, readiness: data ?? null },
      });
    },
);
